// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import moment from "moment"
import { Map, List, Record, Set } from "immutable"

import Flight from "./Flight"
import Transfer from "./Transfer"
import type { PART_TYPE } from "../consts/booking"
import Stop from "./Stop/Stop"

export const TripRecord = Record({
  flights: List(),
  parts: List(),
})

export default class Trip extends TripRecord {
  getId(): string {
    return (
      // @ts-expect-error: Flow to TS migration.
      this.get("flights")
        // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
        .reduce<Array<any>>((res, flight) => res.concat([flight.id]), [])
        .join("|")
    )
  }

  // There should NEVER be trip with more flights, if the only flight is hidden
  isThrowawayTicket(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.get("flights").every((flight) => flight.isThrowawayTicket)
  }

  isHiddenCity(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.get("flights").every((flight) => flight.isHiddenCity)
  }

  getStops(): List<Stop> {
    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    // @ts-expect-error: Flow to TS migration.
    return List(this.get("flights").map((flight) => this.getPrevStop(flight))).shift() // remove the first 'null'
  }

  buildPreviousStop(part: Flight, previousPart: Flight): Stop {
    const previousArrival = previousPart.getIn(["arrival", "where", "code"])
    const nextDeparture = part.getIn(["departure", "where", "code"])

    const differentAirport = previousArrival !== nextDeparture
    const previousStopArrival = previousPart.getIn(["arrival", "when", "utc"])

    const currentStopDeparture = part.getIn(["departure", "when", "utc"])

    const duration = moment.duration(currentStopDeparture.diff(previousStopArrival))

    return new Stop({
      name: part.getIn(["departure", "where", "name"]),
      country: part.getIn(["departure", "where", "country"]),
      code: part.getIn(["departure", "where", "code"]),
      duration,
      bagsRecheckRequired: part.get("bagsRecheckRequired"),
      hasGuarantee: part.get("guarantee"),
      isSelfTransfer: part.get("isSelfTransfer"),
      differentAirport: differentAirport
        ? Map({
            arrival: previousArrival,
            departure: nextDeparture,
          })
        : null,
      containsGroundTransport: this.containsGroundTransport(),
      isLayoverBetweenFlights: this.isLayoverBetweenFlights(part),
      isStopSameCountryAsPrevDeparture: this.isStopSameCountryAsPrevDeparture(part),
      isStopBeforeFirstHiddenCity: !previousPart.get("isHiddenCity") && part.get("isHiddenCity"),
    })
  }

  /**
   * @param part - Part object of this trip - transfer / flight
   * @returns {null | stop}
   */
  getPrevStop(part: Flight): Stop | null | undefined {
    const parts = this.get("parts")
    const index = parts.indexOf(part)
    const previousPart = parts.get(index - 1)

    if (index > 0 && previousPart) {
      return this.buildPreviousStop(part, previousPart)
    }
    return null
  }

  getPreviousNonHiddenStop(part: Flight): Stop | null | undefined {
    const parts = this.get("parts")
    const nonHiddenParts = parts.filter(
      // @ts-expect-error: Flow to TS migration.
      (flight) => !flight.get("isThrowawayTicket") && !flight.get("isHiddenCity"),
    )
    const index = nonHiddenParts.indexOf(part)
    const previousPart = nonHiddenParts.get(index - 1)

    if (index > 0 && previousPart) {
      return this.buildPreviousStop(part, previousPart)
    }
    return null
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDeparture(): Map<string, any> {
    return this.get("flights").first().get("departure")
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getArrival(): Map<string, any> {
    return this.get("flights").last().get("arrival")
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDepartureWithoutHiddenFlights(): Map<string, any> {
    const first = this.get("flights").find(
      // @ts-expect-error: Flow to TS migration.
      (x) => !x.get("isThrowawayTicket") && !x.get("isHiddenCity"),
    )
    return first ? first.get("departure") : null
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getArrivalWithoutHiddenFlights(): Map<string, any> {
    const last = this.get("flights").findLast(
      // @ts-expect-error: Flow to TS migration.
      (x) => !x.get("isThrowawayTicket") && !x.get("isHiddenCity"),
    )
    return last ? last.get("arrival") : null
  }

  getDuration() {
    return moment.duration(
      this.getArrival().get("when").get("utc").diff(this.getDeparture().get("when").get("utc")),
    )
  }

  getDurationWithoutHiddenFlights() {
    const arrivalWithoutHiddenFlights = this.getArrivalWithoutHiddenFlights()
    const departureWithoutHiddenFlights = this.getDepartureWithoutHiddenFlights()
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!arrivalWithoutHiddenFlights || !departureWithoutHiddenFlights) {
      return null
    }
    return moment.duration(
      arrivalWithoutHiddenFlights
        .get("when")
        .get("utc")
        .diff(departureWithoutHiddenFlights.get("when").get("utc")),
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAllAirlines(): List<Map<string, any>> {
    return (
      this.get("flights")
        // @ts-expect-error: Flow to TS migration.
        .reduce((airlines, flight) => {
          const code = flight.get("airline").get("code")
          const type = flight.get("type")

          return airlines.set(code, flight.get("airline").set("type", type))
        }, Map())
        .toList()
    )
  }

  getTypes(): Set<PART_TYPE> {
    // @ts-expect-error: Flow to TS migration.
    return Set(this.get("flights").map((flight) => flight.get("type")))
  }

  /**
   * Check whether departure is different day than arrival
   */
  isLocalOverNight(): boolean {
    return (
      this.getArrival().get("when").get("local").get("M") !==
        this.getDeparture().get("when").get("local").get("M") ||
      this.getArrival().get("when").get("local").get("D") !==
        this.getDeparture().get("when").get("local").get("D")
    )
  }

  isChangeAllowed(hoursAllowedToChange: number): boolean {
    const departure = this.getDeparture()
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
    const time = departure && departure.getIn(["when", "utc"])

    return time ? time.clone().subtract(hoursAllowedToChange, "hours").isAfter() : false
  }

  isLayoverBetweenFlights(part: Flight): boolean {
    const parts = this.get("parts")
    const index = parts.indexOf(part)
    return part.get("type") === "flight" && parts.get(index - 1).get("type") === "flight"
  }

  containsGroundTransport(): boolean {
    const parts = this.get("parts")
    const groundTransports = ["bus", "train"]
    // @ts-expect-error: Flow to TS migration.
    return parts.some((part) => groundTransports.includes(part.get("type")))
  }

  isStopSameCountryAsPrevDeparture(part: Flight): boolean {
    const parts = this.get("parts")
    const index = parts.indexOf(part)
    return (
      part.getIn(["departure", "where", "country"]) ===
      parts.get(index - 1).getIn(["departure", "where", "country"])
    )
  }

  getPreviousPart(part: Flight): Flight | null | undefined {
    const parts = this.get("parts")
    let index = parts.indexOf(part)
    let previousPart = parts.get(index - 1)

    // find the root of the previous connection
    // some hidden flights are not attached to the previous ones
    while (index > 0 && previousPart?.getTo() !== part.getFrom()) {
      index -= 1
      previousPart = parts.get(index - 1)
    }

    return previousPart
  }

  getConnectedHiddenPart(part: Flight): Flight | null | undefined {
    const parts = this.get("parts")
    // @ts-expect-error: Flow to TS migration.
    const hiddenPart = parts.find((p) => p.isHiddenCity)

    // @ts-expect-error: Flow to TS migration.
    if (hiddenPart && part.equals(this.getPreviousPart(hiddenPart))) {
      return hiddenPart
    }

    return null
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS({ flights, parts }: any) {
    return new Trip({
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      flights: List(flights.map(Flight.fromPlainJS)),
      parts: List(
        // @ts-expect-error: Flow to TS migration.
        parts.map((part) =>
          part.type === "flight" ? Flight.fromPlainJS(part) : Transfer.fromPlainJS(part),
        ),
      ),
    })
  }
}
